'use client';

import { useTranslations } from 'next-intl';

type PageTitleProps = {
  content: string;
};
export default function PageTitle({ content }: PageTitleProps) {
  const t = useTranslations();

  return <>{t(content)}</>;
}
